import React from 'react';
import { Container, Row, Col, Card, Progress, Button, CardTitle, CardText } from 'reactstrap';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const items = [
  {
    thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/Homepage%2Bicons_A.png",
    middletext: '1 in 3',
    text: 'More than a third of the world’s malnourished children live in India',
  },
  {
    thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/Homepage%2Bicons_B.png",
    middletext: '2 in 3',
    text: 'More than 2/3rds deaths of under-fives attributed to malnutrition',
  },
  {
    thumbnail: "https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/Mission+10+Million+Meals/impactmidday+mea.png",
    middletext: '95.1M',
    text: '95.1M children deprived of midday meals at school during COVID-19',
  },
];

const CampaignPanelNew = (props) => {

  const { className, title, description, needed, completed, size, image1, tags,
    partnerImage, link, tenantConfig, theme } = props;

  const linkStartUtm = link && link.indexOf('?utm_source') - 1;
  const linkWithoutUtm = linkStartUtm > -1 ? link.substring(0, linkStartUtm) : link;

  const graphictextmissions = items.map((item, gmt) => (
    <Col xs={6} md={4} lg={4} key={gmt} className="">
      <div>
        <img style={{ width: '55%' }} className="missions-panel-right-icons"
          loading="lazy"
          src={item.thumbnail} alt="" />
        <h3 className="text-center missions-panel-right-icons-heading ">{item.middletext}</h3>
        <p className="">{item.text}</p>
      </div>
    </Col>
  ));

  return (
		<Container fluid style={{ padding: '0px' }} className="missions-panel-box">
			<Container>
				<div style={{ marginTop: '1rem' }} className={className}>
					<div
						className="missions-inner-panel missions-panel-mobile"
						style={{}}
					>
						<Row className="missions-panel-outer-box">
							<Col {...size.left} className="missions-panel-mobile">
								<div className="justify-content-center align-self-center">
									<div className="hide-for-desktop">
										<h2 className="missions-panel-right-heading">{title}</h2>
										<p>{description}</p>
									</div>
									<Col className="missions-panel-mobile">
										<a
											href={linkWithoutUtm}
											onClick={() => {
												if (window.eventDispatcher) {
													window.eventDispatcher.dispatchEventSync(
														'homepage-campagin-card',
														{},
														{ amplitude: true }
													);
												}
											}}
											style={{ textDecoration: 'none' }}
										>
											<Card>
												<img
													style={{ width: '100%' }}
													src={`${config.cdnUrl}${image1}`}
													alt={title}
													className="gi-background-image"
													loading="lazy"
												/>
												<div className="card-inner-content">
													<CardTitle>
														<h3>Rise Against Hunger</h3>{' '}
													</CardTitle>
													<CardText style={{ color: '#444444' }}>
														Mission: 10 Million Meals is an endeavor to deliver
														10 million mid-day meals to schoolchildren in one
														year. All it takes is 2,000 donors committing to
														donate ₹2,000 ($30) every month and 43,000 hungry
														children can be fed one hot meal every school day in
														19 states across India.
													</CardText>
												</div>
												<div className="progress-wrapper card-process-wrapper-content">
													{/* <div className="" style={{ paddingBottom: '10px' }}>
                        <span className="supporting-card-bold-text">{needed} supporters needed</span>
                        </div> */}
													<Progress
														className="supporter-process-bar"
														value={completed}
													/>
													<div
														style={{
															paddingTop: '10px',
															paddingBottom: '10px'
														}}
													>
														<span style={{ color: '#444444' }}>
															<span className="monthly-count-supporters">
																{needed}
															</span>{' '}
															supporters needed
														</span>
														<span className="completed-supporters">
															{completed}%{' '}
														</span>
													</div>
												</div>
											</Card>
										</a>
									</Col>
								</div>
							</Col>
							<Col {...size.right} className="right-side-panel-mobile">
								<div>
									<div className="hide-for-mobile">
										<h2 className="missions-panel-right-heading">{title}</h2>
										<p>
											One in three of the world’s malnourished children live in
											India. Our children are going to school hungry. They
											suffer from lack of concentration and reduced cognitive
											development, directly leading to their dropping out of
											school. Join us in our mission to prevent hunger
											diminishing our children’s opportunities to succeed.
										</p>
									</div>
									<div
										className="hide-for-mobile"
										style={{ paddingTop: '1rem', paddingBottom: '1rem' }}
									>
										<Row>{graphictextmissions}</Row>
									</div>

									<Row>
										<Col
											xs="12"
											sm="12"
											md="12"
											lg="6"
											className="campaign-btn-mobile p-0"
										>
											<a
												href={linkWithoutUtm}
												onClick={() => {
													if (window.eventDispatcher) {
														window.eventDispatcher.dispatchEventSync(
															'homepage-campagin-btn',
															{},
															{ amplitude: true }
														);
													}
												}}
											>
												<Button
													style={{ width: '100%' }}
													color="primary"
													className="btn-full-width campaign-panel-givenow"
												>
													Feed a hungry child
												</Button>
											</a>
										</Col>
									</Row>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
			<style global jsx>
				{`
					.image-card-top {
						border-style: none;
					}
					.card-inner-content {
						padding-top: 1rem;
						padding-right: 1rem;
						// padding-bottom: 1rem;
						padding-left: 1rem;
					}
					.card-process-wrapper-content {
						padding-top: 1rem;
						padding-right: 1rem;
						padding-bottom: 1rem;
						padding-left: 1rem;
					}
					.card-price {
						margin-bottom: 10px;
					}
					.card-price h6 {
						margin-bottom: 0;
						font-weight: 600;
					}
					.tag-row {
						margin-bottom: 10px;
					}
					.giveassured-position {
						position: absolute;
						bottom: 3px;
						right: 3px;
						background: white;
						padding: 1px 5px;
						border-radius: 5px;
						box-shadow: 0 2px 2px rgba(50, 50, 93, 0),
							0 1px 2px rgba(0, 0, 0, 0.08);
					}
					.supporting-card-bold-text {
						font-weight: 600;
						font-size: 18px;
						color: #444444;
					}
					.supporter-process-bar.progress {
						height: 8px !important;
					}
					.supporter-process-bar .progress-bar {
						background: #ff5050 !important;
					}
					.completed-supporters {
						float: right;
						color: #666666 !important;
					}
					.monthly-count-supporters {
						color: #666666 !important;
					}
					.missions-panel-box {
						background-image: url('https://give-marketplace-dev.s3.ap-south-1.amazonaws.com/static/images/home/homev2/mission-banner/missions-bg-desktop.jpg');
						// background-color: red;
						height: 100%;
						// opacity: 0.5;
					}
					.missions-card .card {
						width: 22rem;
					}
					.missions-panel-btn {
						height: 50px !important;
						font-size: 1.25rem;
					}
					@media (max-width: 992px) {
						.missions-panel-mobile {
							padding: 0px;
							// margin-bottom: 1rem;
						}
						.campaign-btn-mobile {
							padding: 0px !important;
						}
						.right-side-panel-mobile {
							padding-right: 0px;
							padding-left: 05px;
						}
						.card {
							margin-bottom: 2rem !important;
						}
					}
					.missions-panel-right-icons {
						display: block;
						margin-left: auto;
						margin-right: auto;
					}
					.missions-panel-right-icons-heading {
						font-size: 34px;
					}
					.missions-panel-right-readmore {
						display: inline;
						padding-left: 2rem;
					}
					.missions-panel-outer-box {
						padding-top: 2rem;
						padding-bottom: 2rem;
					}
					@media (max-width: 768px) {
						.missions-panel-right-readmore {
							text-align: center !important;
							display: block;
							padding-top: 1rem;
						}
						.missions-panel-outer-box {
							padding-top: 1rem;
							padding-bottom: 0rem;
							margin-bottom: 2rem;
						}
					}
				`}
			</style>
		</Container>
	);
};

CampaignPanelNew.defaultProps = {
  className: ' d-flex',
  title: 'mission 10 million meals',
  description: 'Join 123 people who have pledged to help our trusted NGO partners make a difference in the lives of countless children by providing them with daily mid day meals.',
  needed: 1270,
  completed: 80,
  size: {
    left: {
      xs: 12,
      sm: 12,
      md: '12',
      lg: '5',
      xl: '5',
    },
    right: {
      xs: 12,
      sm: 12,
      md: '12',
      lg: '7',
      xl: '7',
    },
  },
  tags: [
    {
      type: 'extremeneed',
      design: 'capsule',
    },
  ],
  image: '/static/images/campaign/target-image1.jpg',
  partnerImage: '/static/images/campaign/mission-partner-ngo.png',
  link: '#'
};

export default CampaignPanelNew;
